const NOOP = () => () => {};
export const useAnimatedKeyboardHandler = NOOP;
export const useFocusedInputLayoutHandler = NOOP;
//# sourceMappingURL=reanimated.js.map